/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_alert_total_file_size = /** @type {(inputs: { totalFileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `Celková velikost souborů přesahuje limit ${i.totalFileSizeLimitMo} MB`
};

const da_contact_alert_total_file_size = /** @type {(inputs: { totalFileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `Den samlede filstørrelse overstiger grænsen på ${i.totalFileSizeLimitMo} MB`
};

const de_contact_alert_total_file_size = /** @type {(inputs: { totalFileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `Die Gesamtgröße der Dateien überschreitet das Limit von ${i.totalFileSizeLimitMo} MB`
};

const en_contact_alert_total_file_size = /** @type {(inputs: { totalFileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `The total size of the files exceeds the limit of ${i.totalFileSizeLimitMo} MB`
};

const es_contact_alert_total_file_size = /** @type {(inputs: { totalFileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `El tamaño total de los archivos supera el límite de ${i.totalFileSizeLimitMo} MB`
};

const fr_contact_alert_total_file_size = /** @type {(inputs: { totalFileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `La taille totale des fichiers dépasse la limite de ${i.totalFileSizeLimitMo} Mo`
};

const hu_contact_alert_total_file_size = /** @type {(inputs: { totalFileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `A fájlok teljes mérete meghaladja a ${i.totalFileSizeLimitMo} MB korlátot`
};

const it_contact_alert_total_file_size = /** @type {(inputs: { totalFileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `La dimensione totale dei file supera il limite di ${i.totalFileSizeLimitMo} MB`
};

const nl_contact_alert_total_file_size = /** @type {(inputs: { totalFileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `De totale bestandsgrootte is groter dan ${i.totalFileSizeLimitMo} MB`
};

const pl_contact_alert_total_file_size = /** @type {(inputs: { totalFileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `Łączny rozmiar plików przekracza limit ${i.totalFileSizeLimitMo} MB`
};

const pt_contact_alert_total_file_size = /** @type {(inputs: { totalFileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `O tamanho total dos arquivos excede o limite de ${i.totalFileSizeLimitMo} MB`
};

const sv_contact_alert_total_file_size = /** @type {(inputs: { totalFileSizeLimitMo: NonNullable<unknown> }) => string} */ (i) => {
	return `Den totala filstorleken överskrider gränsen ${i.totalFileSizeLimitMo} MB`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ totalFileSizeLimitMo: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_alert_total_file_size = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_alert_total_file_size(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_alert_total_file_size", locale)
	if (locale === "cs") return cs_contact_alert_total_file_size(inputs)
	if (locale === "da") return da_contact_alert_total_file_size(inputs)
	if (locale === "de") return de_contact_alert_total_file_size(inputs)
	if (locale === "en") return en_contact_alert_total_file_size(inputs)
	if (locale === "es") return es_contact_alert_total_file_size(inputs)
	if (locale === "fr") return fr_contact_alert_total_file_size(inputs)
	if (locale === "hu") return hu_contact_alert_total_file_size(inputs)
	if (locale === "it") return it_contact_alert_total_file_size(inputs)
	if (locale === "nl") return nl_contact_alert_total_file_size(inputs)
	if (locale === "pl") return pl_contact_alert_total_file_size(inputs)
	if (locale === "pt") return pt_contact_alert_total_file_size(inputs)
	return sv_contact_alert_total_file_size(inputs)
};
export { contact_alert_total_file_size as "contact.alert.total_file_size" }